import { useCallback } from 'react';
import { useSmartLinkClientExtension } from '@atlaskit/link-client-extension';
import { useSmartLinkContext } from '@atlaskit/link-provider';
const useRelatedUrls = () => {
  const {
    connections
  } = useSmartLinkContext();
  const clientExt = useSmartLinkClientExtension(connections.client);
  return useCallback(async url => {
    return await clientExt.relatedUrls(url);
  }, [clientExt]);
};
export default useRelatedUrls;